import React, { ReactElement } from 'react';

import {
  Container,
  GridItem,
  ErrorSummary,
  ErrorSummaryItem,
  Paragraph,
  Notification,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { Link } from 'components/tagging';
import dataQaIds from 'dataModel/dataQaIds';

import {
  ACCOUNT_NUMBER,
  BUSINESS_NAME,
  SORT_CODE,
} from '../../../utils/constant';
import { BusinessNotificationPropsType } from '../../../utils/types';
import { AboutBusinessContent } from '../AboutBusinessContent';

function BusinessNotification({
  isExistSortCode,
  errors,
  hasError,
}: BusinessNotificationPropsType): ReactElement {
  const { aboutBusinessContent } = useContent<AboutBusinessContent>();

  return (
    <Container padding="none">
      {aboutBusinessContent?.map(
        ({
          info,
          warningTextForRegister,
          warningTextForSortCode,
          errorHeading,
          ocisErrorInfo,
          orCallUsOn,
          ocisHelpContact,
          forSomeHelp,
        }) => (
          <React.Fragment key="content">
            {!Object.keys(errors).length || (
              <GridItem data-qa-id={dataQaIds.aboutBusiness.errorSummary}>
                <ErrorSummary title={errorHeading}>
                  <ErrorSummaryItem href={`#${BUSINESS_NAME}`}>
                    {errors?.businessName?.message}
                  </ErrorSummaryItem>
                  <ErrorSummaryItem href={`#${SORT_CODE}`}>
                    {errors?.sortCode?.message}
                  </ErrorSummaryItem>
                  <ErrorSummaryItem href={`#${ACCOUNT_NUMBER}`}>
                    {errors?.accountNumber?.message}
                  </ErrorSummaryItem>
                </ErrorSummary>
              </GridItem>
            )}

            {isExistSortCode && (
              <GridItem data-qa-id={dataQaIds.aboutBusiness.existSortCodeError}>
                <Notification sentiment="warning">
                  <Paragraph>{warningTextForRegister}</Paragraph>
                  <Paragraph marginBottom="none">
                    {warningTextForSortCode}
                  </Paragraph>
                </Notification>
              </GridItem>
            )}

            {hasError && (
              <GridItem
                data-qa-id={dataQaIds.aboutBusiness.accountNotFoundError}
              >
                <Notification sentiment="critical">
                  <Paragraph>{ocisErrorInfo}</Paragraph>
                  <Paragraph marginBottom="none">
                    {orCallUsOn}{' '}
                    <Link
                      href={`tel:${ocisHelpContact}`}
                      event={`JourneyEvent: 'Click to Call', EventAction: 'Click to Call',EventNarrative:${ocisHelpContact}`}
                    >
                      {ocisHelpContact}
                    </Link>{' '}
                    {forSomeHelp}
                  </Paragraph>
                </Notification>
              </GridItem>
            )}

            <GridItem>
              <Notification>{info}</Notification>
            </GridItem>
          </React.Fragment>
        ),
      )}
    </Container>
  );
}

export default BusinessNotification;
